<template>
  <div class="col-xl-3 col-lg-4">
    <div class="m-portlet m-portlet--full-height  ">
      <div class="m-portlet__body">
        <div class="m-card-profile">
          <div class="m-card-profile__title m--hide">
            {{ 'my_profile' | capitalize }}
          </div>
          <!-- <div class="m-card-profile__pic">
            <div class="m-card-profile__pic-wrapper">
              <img src="/media/img/logo_m.png" alt=""/>
            </div>
          </div> -->
          <div class="m-card-profile__details">
            <span class="m-card-profile__name">
              {{ fullName }}
            </span>
            <!-- <span href="" class="m-card-profile__email">
              {{ user.email }}
            </span> -->
          </div>
        </div>
        <ul class="m-nav m-nav--hover-bg m-portlet-fit--sides">
          <li class="m-nav__separator m-nav__separator--fit"></li>
          <li class="m-nav__section m--hide">
            <span class="m-nav__section-text">
              {{ 'section' | capitalize }}
            </span>
          </li>
          <li class="m-nav__item">
            <a href="../header/profile&amp;demo=default.html" class="m-nav__link">
              <i class="m-nav__link-icon flaticon-profile-1"></i>
              <span class="m-nav__link-title">
                <span class="m-nav__link-wrap">
                  <span class="m-nav__link-text">
                    {{ 'my_profile' | titleize }}
                  </span>
                </span>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: { type: Object, required: true }
  },
  computed: {
    fullName () {
      return `${this.user.first_name} ${this.user.last_name}`
    }
  }
}
</script>




// WEBPACK FOOTER //
// BarContainer.vue